<template>
  <div class="shop-root">
    <header class="shop-header">
      <div class="ps-container header-inner">
        <router-link to="/" class="logo">Pomelo Shop</router-link>
        <nav class="nav">
          <router-link to="/products">全部商品</router-link>
          <router-link to="/merchants">商家</router-link>
          <router-link v-if="auth.isAuthed" to="/favorites">收藏</router-link>
          <router-link v-if="auth.isAuthed" to="/follows">关注</router-link>
          <router-link to="/feedback">反馈</router-link>
          <router-link to="/merchant-apply">商家入驻</router-link>
          <router-link to="/web3-tools">链上数据</router-link>
        </nav>
        <div class="header-actions">
          <router-link to="/cart" class="cart-link">购物车</router-link>
          <template v-if="auth.isAuthed">
            <router-link to="/orders">我的订单</router-link>
            <router-link to="/addresses">地址</router-link>
            <router-link to="/account">{{ auth.displayName }}</router-link>
            <button type="button" class="link-btn" @click="logout">退出</button>
          </template>
          <template v-else>
            <router-link to="/login">登录</router-link>
            <router-link to="/register">注册</router-link>
          </template>
        </div>
      </div>
    </header>
    <main class="shop-main">
      <router-view />
    </main>
    <footer class="shop-footer">
      <div class="ps-container ps-muted">买家 PC 站 · 接口与 App 买家端一致</div>
    </footer>
  </div>
</template>

<script setup>
import { useAuthStore } from '@/stores/auth'
import { useRouter } from 'vue-router'

const auth = useAuthStore()
const router = useRouter()

function logout() {
  auth.logout()
  router.push('/')
}
</script>

<style scoped>
.shop-root {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}
.shop-header {
  background: #fff;
  border-bottom: 1px solid var(--ps-border);
  position: sticky;
  top: 0;
  z-index: 100;
}
.header-inner {
  display: flex;
  align-items: center;
  gap: 24px;
  padding-top: 14px;
  padding-bottom: 14px;
  flex-wrap: wrap;
}
.logo {
  font-weight: 700;
  font-size: 18px;
  color: var(--ps-text);
  text-decoration: none;
}
.logo:hover {
  text-decoration: none;
  color: var(--ps-primary);
}
.nav {
  display: flex;
  gap: 16px;
  flex: 1;
  flex-wrap: wrap;
}
.nav a {
  color: var(--ps-text);
  font-size: 14px;
}
.nav a.router-link-active {
  color: var(--ps-primary);
}
.header-actions {
  display: flex;
  gap: 14px;
  align-items: center;
  font-size: 14px;
}
.cart-link {
  font-weight: 600;
}
.link-btn {
  background: none;
  border: none;
  color: var(--ps-primary);
  cursor: pointer;
  font-size: 14px;
  padding: 0;
}
.shop-main {
  flex: 1;
}
.shop-footer {
  padding: 24px 0;
  text-align: center;
  border-top: 1px solid var(--ps-border);
  background: #fff;
}
</style>
